import api from '../../../services/api';

// employee providers
export const EmployeesHTTP = {
  get: (params = {}) => api.get('/employees', {params}),
  getById: (id = '') => api.get(`/employees/${id}`),
  create: (payload = {}) => api.post('/employees', payload),
  update: (id = '', payload = {}) => api.put(`/employees/${id}`, payload),
  getTimeline: (id = '') => api.get(`/users/timeline/${id}`),
};
